(function (angular, _, window) {
    'use strict';

    /**
     * Gets the list of Services that are attached to the service type.
     */
    window.THF.Angular.LiveQuoteTool
        .factory('ProductsModel', ['$http', '$q', function ($http, $q) {
            var ProductsModel = function () {

            };

            ProductsModel.prototype = {
                /**
                 * Possible Types are:
                 *
                 * - hospital
                 * - extras
                 *
                 * @param type
                 * @returns {deferred.promise|{then, always}}
                 */
                byType: function (type) {
                    var scope = this;
                    var deferred = $q.defer();

                    var url = false;
                    if (type === 'hospital') {
                        url = '/api/v1/product/HospitalProducts/Get';
                    }
                    else if (type === 'extras') {
                        url = '/api/v1/product/ExtrasProducts/Get';
                    }

                    if (url === false) {
                        url = '/static/js/src/Angular/thfLiveQuoteTool/json/products/' + type + '.json';
                    }


                    $http.get(url, {
                            cache: true
                        })
                        .success(function (products) {
                            deferred.resolve(products);
                        })
                        .error(function () {
                            deferred.reject();
                        });

                    return deferred.promise;
                },
                /**
                 *
                 * @param type
                 * @param productCode
                 * @returns {deferred.promise|{then, always}}
                 */
                byProductCode: function (type, productCode) {
                    var deferred = $q.defer();
                    var scope = this;

                    scope.byType(type).then(function (items) {
                        if (items.length > 0) {
                            var filtered = _.filter(items, function (item) {
                                var result = true;
                                if( item.defaultProductCode == productCode ) {
                                    result = true;
                                }
                                else if (_.indexOf(item.productCodes, productCode) === -1) {
                                    result = false;
                                }
                                return result;
                            });
                            deferred.resolve(filtered);
                        }
                        else {
                            deferred.reject();
                        }
                    });
                    return deferred.promise;
                },
                byProductId: function (type, productId) {
                    var deferred = $q.defer();
                    var scope = this;

                    scope.byType(type).then(function (items) {
                        console.log( items );
                        if (items.length > 0) {
                            var filtered = _.filter(items, {id: productId});
                            deferred.resolve(filtered);
                        }
                        else {
                            deferred.reject();
                        }
                    });
                    return deferred.promise;
                }
            };
            return new ProductsModel();
        }]);

})(angular, _, window);
